
import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import axios from "../../API/axios";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";

function LoginMobileHeader({ handleMobile }) {
    const sessionId = localStorage.getItem("sessionId");
    const profilPic = localStorage.getItem("profilPic");
    const entityName = localStorage.getItem("entityName");
    const email = localStorage.getItem("email");
    const userUID = localStorage.getItem("userUID");
    const userType = localStorage.getItem("userType");
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
      const navigate = useNavigate();
    


    const [unAuthorizeError, setUnAuthorizeError] = useState("");
         const [unauthModal, setUnauthModal] = useState(false);
          const handleunauthModal = () => setUnauthModal(true);
          const handlecloseunauthModal = () => setUnauthModal(false);
    

    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);

    // ........................................................................

    const [profileStatus, setProfileStatus] = useState(false);

    const checkProfile = async () => {
        const data = { sessionId: sessionId };
        try {
            // const response = await axios.post("/CandidateData/Check", data);
            // const profileExists = response.data.responseData;

            // setProfileStatus(profileExists);

            axios
			.post(`/CandidateData/Check`, data)
			.then((response) => { 
               const profileExists = response.data.responseData;
               setProfileStatus(profileExists || false);

			})
			.catch((error) => {
				console.log(error);
				if (error.response && error.response.status === 409) {
				 console.error("Unexpected error:", error);
				 setUnAuthorizeError(error.response.data.message)
				 handleunauthModal()
				  }else  if (error.response && error.response.status === 400) {
                    // toast.error(error.response.message)
                    console.log("data",error.response.status);
                    
                    // setIsError(true);
                } else {
                    console.log(error);
                }
                // else {
				//  console.error("Unexpected error:", error);


				// 	// toast.error(error.message);
				// 	  }
			});


        } catch (error) {
            console.error("Error fetching profile status:", error);
            return false;
        }
    };

    useEffect(() => {
        checkProfile();
    }, []);


    return (
        <>
        <div className="menu-mobile-popup">
            <div className="modal-menu__backdrop" onClick={handleMobile}></div>
            <div className="widget-filter">
                <div className="mobile-header align-items-start pb-0">
                    <Link to="#">
                        <img
                            // src={avt}
                            src={profilPic}
                            width={40}
                            alt="User Logo"
                            className="userProfileHeader"
                        />
                    </Link>

                    <ul className="p-0 ">
                        <li>
                            <div className=" d-flex HeaderFLName f-14">
                                {/* <h6> */}
                                {" "}
                                {`${entityName} `}
                                {/* </h6> */}
                            </div>
                            <div className="HeaderEmail f-14">
                                {/* <h6>  */}
                                {email}
                                {/* </h6> */}
                            </div>
                            <div className="HeaderUserType f-14">
                                {/* <h6>  */}
                                {userType}
                                {/* </h6> */}
                            </div>
                        </li>
                    </ul>

                    <div>
                        <Link className="title-button-group close-icon-button-group" onClick={handleMobile}>
                            <i className="icon-close"></i>
                        </Link>

                    </div>

                </div>


                <div className="content-tab">
                    <div className="nav-wrap">
                        <nav className="main-nav mobile">
                            <ul id="menu-primary-menu" className="menu" style={{ paddingLeft: "0px" }}>


                                <li className="menu-item d-flex align-items-center">
                                    <HomeSharpIcon />
                                    <Link to="/Home" className="ms-2">Home</Link>
                                </li>

                                <li className="menu-item d-flex align-items-center">
                                    <WorkSharpIcon />
                                    <Link to="/Jobs" className="ms-2">Jobs</Link>
                                </li>

                                <li className="menu-item  menu-item-has-children-mobile">
                                    <div className="d-flex align-items-center">

                                        <WorkHistorySharpIcon />
                                        <button
                                            // to="#"
                                            className="iteam-menu ms-2"
                                            onClick={() => {
                                                handleToggle("employers");
                                            }}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                color: "inherit",
                                                cursor: "pointer",
                                                padding: 0,
                                                fontWeight: 200,
                                                display: "flex"
                                            }}

                                        >
                                            Manage Job
                                        </button>
                                    </div>
                                    <Collapse isOpened={toggle.key === "employers"}>
                                        <ul
                                            className="sub-menu-mobile ms-2"
                                            style={{
                                                display: `${toggle.key === "employers" ? "block" : "none"
                                                    }`,
                                            }}
                                        >

                                            <li className="menu-item d-flex align-items-center">
                                                {/* <WorkSharpIcon /> */}
                                                <Link to="/Saved-jobs" className="ms-2">Saved Jobs</Link>
                                            </li>
                                            <li className="menu-item d-flex align-items-center">
                                                {/* <WorkSharpIcon /> */}
                                                <Link to="/Applied-jobs" className="ms-2">Applied Jobs</Link>
                                            </li>

                                        </ul>
                                    </Collapse>


                                </li>

                                <li className="menu-item d-flex align-items-center">
                                    <AccountCircleSharpIcon />
                                    {/* <Link to={`/Resume/Candidate?userUID=${userUID}`} className="ms-2">Profile</Link> */}
                                    {profileStatus ? <Link to={`/Resume/Candidate?userUID=${userUID}`} className="ms-2" >Profile</Link> :
                                        <Link to="/Candidate" className="ms-2">Complete Profile</Link>
                                    }
                                </li>
                                <li className="menu-item d-flex align-items-center">
                                    <SettingsSharpIcon />
                                    <Link to="/Settings" className="ms-2">Settings</Link>
                                </li>
                                <li className="menu-item d-flex align-items-center">
                                    <LogoutSharpIcon />
                                    <NavLink
                                        to="/Login"
                                        onClick={() => {
                                            const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
                                            localStorage.clear(); // Clear all localStorage
                                            if (isDarkValue !== null) {
                                                localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
                                            }
                                        }}
                                        className="ms-2"
                                    >
                                        Logout
                                    </NavLink>
                                </li>

                            </ul>
                        </nav>
                    </div>
                </div>

            </div>
        </div>


        {/* ...............UnAuthorize modal............  */}
                                                        {unAuthorizeError ? (
                                                              <Modal show={unauthModal} centered>
                                                              <Modal.Header>
                                                                  <Modal.Title>Unauthorize session expired</Modal.Title> 
                                                              </Modal.Header>
                                                              <Modal.Body className="settings">
                                                                  <div className=" mb-3">
                                                                      <p>{unAuthorizeError}</p>
                                                                  </div>
                                                              </Modal.Body>
                                                              <Modal.Footer>
                                                              <Link
                                                                      className="pointer"
                                                                      to="/Login"
                                                                      onClick={() => {
                                                                      localStorage.removeItem("token"); // Remove authentication token
                                                                      sessionStorage.removeItem("sessionId"); // Also clear from session storage if used
                                                                      localStorage.removeItem("Module"); // Add this to clear stored role
                                                                    

                                                                    }}
                                                                  >
                                                                    <button className="btn btn-danger ">Login</button>
                                                                  </Link>
                                                                {/* <button onClick={handleConfirmBlock} className="btn btn-danger me-2">Login</button>  */}
                                              
                                                              </Modal.Footer>
                                              
                                                          </Modal>
                                                          ) : (
                                                            ""
                                                          )}

        </>
    );
}

export default LoginMobileHeader;
